export default __webpack_public_path__ + "0b479be6ebe8ec8fded621bf034bf0ba.svg";